import { ResumeCourse } from '../../types';
import { RichTextEditor } from '../ui/RichTextEditor';

interface CoursesSectionProps {
    courses: ResumeCourse[];
    onChange: (courses: ResumeCourse[]) => void;
}

const blankCourse = (): ResumeCourse => ({
    id: crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36),
    course: '',
    institution: '',
    startDate: '',
    endDate: '',
    description: '',
    url: '',
});

export function CoursesSection({ courses, onChange }: CoursesSectionProps) {
    const handleChange = (id: string, updates: Partial<ResumeCourse>) => {
        onChange(courses.map(course => (course.id === id ? { ...course, ...updates } : course)));
    };

    const handleAdd = () => {
        onChange([...courses, blankCourse()]);
    };

    const handleRemove = (id: string) => {
        onChange(courses.filter(course => course.id !== id));
    };

    return (
        <div className="space-y-4">
            <div className="flex items-center justify-between">
                <h3 className="text-lg font-semibold">Courses</h3>
                <button
                    type="button"
                    onClick={handleAdd}
                    className="text-sm text-primary-600 hover:text-primary-800"
                >
                    + Add course
                </button>
            </div>

            {courses.map((course, index) => (
                <div key={course.id} className="border border-gray-200 rounded-lg p-3 space-y-2">
                    <div className="flex items-center justify-between">
                        <span className="text-sm text-gray-500">Entry {index + 1}</span>
                        <button
                            type="button"
                            onClick={() => handleRemove(course.id)}
                            className="text-xs text-red-500"
                        >
                            Remove
                        </button>
                    </div>
                    <div className="grid grid-cols-2 gap-2">
                        <input
                            className="input"
                            placeholder="Course"
                            value={course.course}
                            onChange={(e) => handleChange(course.id, { course: e.target.value })}
                        />
                        <input
                            className="input"
                            placeholder="Institution"
                            value={course.institution || ''}
                            onChange={(e) => handleChange(course.id, { institution: e.target.value })}
                        />
                    </div>
                    <div className="grid grid-cols-2 gap-2">
                        <input
                            type="text" inputMode="numeric" pattern="[0-9]{4}-[0-9]{2}"
                            className="input"
                            placeholder="YYYY-MM"
                            value={course.startDate || ''}
                            onChange={(e) => handleChange(course.id, { startDate: e.target.value })}
                        />
                        <input
                            type="text" inputMode="numeric" pattern="[0-9]{4}-[0-9]{2}"
                            className="input"
                            placeholder="YYYY-MM"
                            value={course.endDate || ''}
                            onChange={(e) => handleChange(course.id, { endDate: e.target.value })}
                        />
                    </div>
                    <input
                        className="input"
                        placeholder="Certificate URL (optional)"
                        type="url"
                        value={course.url || ''}
                        onChange={(e) => handleChange(course.id, { url: e.target.value })}
                    />
                    <RichTextEditor
                        placeholder="Description"
                        minHeight="80px"
                        value={course.description || ''}
                        onChange={(value) => handleChange(course.id, { description: value })}
                    />
                </div>
            ))}
        </div>
    );
}


